import { cityIn } from 'lvovich';
import { shape, string, arrayOf, number, bool } from 'prop-types';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import metaActions from '../../../store/actions/meta';
import { getSelectedPvz } from '../../../store/selectors';
import { formatAmount } from '../../../utils'

import Button from '../../Button';
import Modal from '../../Modal';
import Map from '../../Map';

import s from './index.module.css';

const OffersMessage = ({ offers, mapOffers, location, onSelectLocation, detailInfo }) => {
  const dispatch = useDispatch();
  const selectedPvz = useSelector(getSelectedPvz);
  const [isShowModal, setIsShowModal] = useState(false);
  const selectedCityText = location && location.name ? cityIn(location.name) : cityIn('Москва');

  const onClick = () => setIsShowModal(true);
  const onClose = () => {
    dispatch(metaActions.resetSelectedPvz);
    setIsShowModal(false);
  };

  const handleSelectLocation = (item) => {
    onSelectLocation(item);
    onClose();
  };

  const selectShopAddress = (offer) => {
    const matchedMapOffer = mapOffers && mapOffers.find(({ key }) => key === offer.key);
    dispatch(metaActions.setSelectedPvz(matchedMapOffer || offer));
    setIsShowModal(true);
  };

  const offersLatitudes = mapOffers.map(({ latitude }) => latitude).filter(value => Boolean(value));
  const offersLongitudes = mapOffers.map(({ longitude }) => longitude).filter(value => Boolean(value));
  const meanLatitude = offersLatitudes.length && offersLatitudes.reduce((acc, curr) => acc + curr, 0) / offersLatitudes.length;
  const meanLongitude = offersLongitudes.length && offersLongitudes.reduce((acc, curr) => acc + curr, 0) / offersLongitudes.length;

  const selectedPvzHasCoordinates = selectedPvz && selectedPvz.latitude && selectedPvz.longitude;
  const centerCoordinates = selectedPvzHasCoordinates ? [selectedPvz.latitude, selectedPvz.longitude] : [meanLatitude, meanLongitude];

  return (
    <div className={s.wrapper}>
      <div className={s.detailInfo}>{detailInfo}</div>
      <div className={s.offersWrapper}>
        {
          offers.map((offer, index) => {
            const delivery = offer.deliveryDays > 0 ? `${offer.deliveryDays} д.` : 'сегодня';

            return (
              <React.Fragment key={offer.key}>
                <span className={s.offerPosition}>{index + 1}.</span>
                <span className={s.offerAddress} onClick={() => selectShopAddress(offer)}>{offer.sellerAddress}</span>
                <span className={s.offerDelivery}>{delivery}</span>
                <span className={s.offerPrice}>{formatAmount(offer.price, true)} ₽</span>
              </React.Fragment>
            )
          })
        }
      </div>

      <Button className={s.mapButton} view="button" background="blue" onClick={onClick}>Открыть на карте</Button>

      {isShowModal &&
        <Modal className={s.modal} onClose={onClose} showClose={false} wrapperClassName={s.modalWrapper}>
          <>
            <div className={s.offers}>
              <h2 className={s.offersHeader}>Предложения магазинов в {selectedCityText}</h2>
              <div className={s.offersInfo}>Выберите пункт самовывоза сейчас, от этого зависит цена и срок</div>
            </div>
            <Button className={s.buttonClose} onClick={onClose} />
            <Map
              className={s.map}
              data={mapOffers}
              onSelectLocation={handleSelectLocation}
              centerCoordinates={centerCoordinates}
              selectedPin={selectedPvz.key}
            />
          </>
        </Modal>
      }
    </div>
  );
};

OffersMessage.propTypes = {
  offers: arrayOf(shape({
    offerKey: string,
    sellerAddress: string,
    deliveryDays: number,
    price: number,
    quantity: number
  })),
  mapOffers: arrayOf(shape({
    offerKey: string,
    sellerName: string,
    sellerAddress: string,
    longitude: number,
    latitude: number,
    deliveryDays: number,
    price: number,
    quantity: number,
  })),
  location: shape({
    id: number,
    name: string,
    isPopular: bool,
  }),
  detailInfo: string,
};

OffersMessage.defaultProps = {
  offers: [],
  mapOffers: [],
  location: {},
  detailInfo: '',
};

export default OffersMessage;
